import englishMessages from 'ra-language-english';

export const en = {
  ...englishMessages,
  ra: {
    ...englishMessages.ra,
    page: {
      ...englishMessages.ra?.page,
      dashboard: 'Dashboard',
      empty: 'No records found',
      invite: 'Invite User',
      loading: 'Loading...',
    },
    message: {
      ...englishMessages.ra?.message,
      loading: 'Please wait a moment.',
      empty: 'No data to display.',
    },
    navigation: {
      ...englishMessages.ra?.navigation,
      no_results: 'No data to display.',
    },
    action: {
      ...englishMessages.ra?.action,
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      cancel: 'Cancel',
      refresh: 'Refresh',
      show: 'Show',
      list: 'List',
      export: 'Export',
      add: 'Add',
      test: 'Test Connection',
      reset: 'Reset',
    },
  },
  resources: {
    'events-v2': {
      name: 'Events (v2)',
      fields: {
        id: 'ID',
        name: 'Event Name',
        type: 'Type',
        venue: 'Venue',
        city: 'City',
        category: 'Category',
        startdate: 'Starts at',
        enddate: 'Ends at',
        isVerified: 'Verified / Visible',
        totalRevenue: 'Total Revenue',
        status: 'Status',
      },
    },
    venues: {
      name: 'Venue |||| Venues',
      fields: {
        name: 'Venue Name',
        city: 'City',
        address: 'Address',
        capacity: 'Capacity',
        phone: 'Phone',
      },
    },
    users: {
      name: 'User |||| Users',
      fields: {
        id: 'ID',
        name: 'Full Name',
        surname: 'Last Name',
        createDateTime: 'Date / Time',
        gender: 'Gender',
        mobile: 'Mobile',
        email: 'Email',
        crole: 'Role',
        country: 'Country',
        city: 'City',
        verified: 'Verified',
        sales: 'Sales',
        edit: 'Edit',
      },
    },
    cities: {
      name: 'City |||| Cities',
      fields: {
        name: 'City Name',
      },
    },
    organisationCompanies: {
      name: 'Organisation Company |||| Organisation Companies',
      fields: {
        name: 'Company Name',
        email: 'Email',
        phone: 'Phone',
      },
    },
    salePoints: {
      name: 'Sale Point |||| Sale Points',
    },
    affiliates: {
      name: 'Affiliate |||| Affiliates',
    },
    saleAgents: {
      name: 'Sale Agent |||| Sale Agents',
    },
    promoters: {
      name: 'Promoter |||| Promoters',
    },
    groupEvents: {
      name: 'Group Event |||| Group Events',
    },
    categories: {
      name: 'Category |||| Categories',
    },
    subcategories: {
      name: 'Sub Category |||| Sub Categories',
    },
    venueCategories: {
      name: 'Venue Category |||| Venue Categories',
    },
    layouts: {
      name: 'Layout |||| Layouts',
    },
    systemParameters: {
      name: 'System Parameter |||| System Parameters',
    },
    appVersionConfigs: {
      name: 'Version Config |||| Version Configs',
    },
    homeSections: {
      name: 'Home Section |||| Home Sections',
    },
    heros: {
      name: 'Home Special Event Hero |||| Home Special Event Hero',
    },
    events: {
      name: 'Event V1 Archive |||| Event V1 Archive',
    },
    dashboard: {
      name: 'Dashboard',
    },
    payments: {
      name: 'Payment |||| Payments',
    },
    sessionEvents: {
      name: 'Session Events Archive |||| Session Events Archive',
    },
    affiliateForm: {
      name: 'Affiliate Application |||| Affiliate Applications',
    },
    eventCreationApplications: {
      name: 'Application |||| Applications',
    },
    featureds: {
      name: 'Featured |||| Featured',
    },
    eventTags: {
      name: 'Event Tag |||| Event Tags',
    },
    eventLogs: {
      name: 'Event Log |||| Event Logs',
    },
    verificationLogs: {
      name: 'Verification Log |||| Verification Logs',
    },
    paymentLogs: {
      name: 'Sale Log |||| Sale Logs',
    },
    cronLogs: {
      name: 'Cron Log |||| Cron Logs',
    },
    stocks: {
      name: 'Stock |||| Stocks',
    },
    pages: {
      name: 'Page |||| Pages',
    },
    news: {
      name: 'Blog |||| Blogs',
    },
    scripts: {
      name: 'Script |||| Scripts',
    },
    settlementCategories: {
      name: 'Accountancy Item |||| Accountancy Items',
    },
    deleteUserRequests: {
      name: 'Delete Request |||| Delete Requests',
    },
    sales: {
      name: 'Sale |||| Sales',
      fields: {
        id: 'ID',
        'user.name': 'User',
        userName: 'User',
        createdate: 'Sale Date',
        'event.name': 'Event Name',
        eventName: 'Event Name',
        userMobile: 'User Mobile',
        channel: 'Channel',
        soldBy: 'Sold By',
        payment: 'Payment (₺)',
        paymentType: 'Payment Type',
        oid: 'Order ID',
        productsCount: '# Products',
        product: 'Product',
        coupon: 'Coupon',
        status: 'Status',
        actions: 'Refund Request / Status',
      },
    },
    tickets: {
      name: 'Ticket |||| Tickets',
      fields: {
        id: 'ID',
        pnr: 'PNR',
        print: 'Print Ticket',
        channel: 'Sale Channel',
        userName: 'User',
        eventName: 'Event Name',
        created: 'Sale Date',
        product: 'Product',
        productKey: 'Product Key',
        isUsed: 'Is Used?',
        refund: 'Refund',
      },
    },
    refundRequests: {
      name: 'Refund Request |||| Refund Requests',
      fields: {
        status: 'Status',
        user: 'User',
        userEmail: 'Email',
        eventName: 'Event',
        productInfo: 'Ticket / Product',
        ticketPnr: 'PNR',
        createdate: 'Refund Date',
        processedBy: 'Refunded By',
      },
    },
  },
  refund: {
    title: 'Refund Requests',
    view_refund: 'View Refund',
    view_detail: 'View Detail',
    status_waiting: 'Refund waiting',
    status_scheduled: 'Scheduled',
    status_done: 'Completed',
    status_pending: 'Pending',
    status_approved: 'Approved',
    status_rejected: 'Rejected',
    status_completed: 'Completed',
    status_failed: 'Failed',
  },
  report: {
    title: 'Sale Report',
    export_report: 'Export Report',
    venue_organisator_details: 'Venue / Organisator Details',
    venue: 'Venue',
    address: 'Address',
    organisator_companies: 'Organisator Companies',
    venue_prefix: 'Venue',
    organisation_prefix: 'Organisation Company',
    total: 'Total',
    summary: 'Summary',
    sales: 'Sales',
    total_sale: 'Total Sale',
    coupons: 'Coupons',
    total_discount: 'Total Discount',
    remaining_payments: 'Remaining Payments',
    total_remaining_amount: 'Total Remaining Amount',
    total_revenue: 'Total Revenue',
    total_coupon_discount: 'Total Coupon Discount',
    organisator_sales_cash: 'Organisator Sales (Cash)',
    sub_total: 'Sub Total',
    gise_fee: 'Gişe Kıbrıs Fee',
    adjustments: 'Adjustments',
    type: 'Type',
    item_note: 'Item / Note',
    amount: 'Amount',
    settlement_net: 'Settlement Net',
    total_payable: 'Total Payable',
    add_expense: 'Add Expense',
    add_income: 'Add Income',
    pay: 'Pay',
    no_seller_records: 'No seller records in this item.',
    seller: 'Seller',
    user: 'User',
    contact: 'Contact',
    count: 'Count',
    sales_count_suffix: 'sales',
    export_report_excel: 'Export Report — Excel',
    export_desc: 'Select sections to include in Excel. Each selection is a separate sheet.',
    select_all: 'Select All',
    clear_all: 'Clear All',
    selected_count: 'Selected (%{count})',
    download_excel: 'Download Excel',
    used: 'used',
    received: 'received',
    expense_used: 'Expense used',
    income_received: 'Income received',
    expense: 'Expense (Spent)',
    income: 'Income (Received)',
    add_expense_title: 'Add Expense',
    add_income_title: 'Add Income',
    add_expense_hint: 'This amount will be counted as spent/used from the budget.',
    add_income_hint: 'This amount will be counted as received into the budget.',
    adjustment_detail: 'Adjustment Detail',
    date: 'Date',
    added_by: 'Added By',
    documents: 'Documents',
    no_documents: 'No documents',
    note: 'Note',
    add_document: 'Add Document',
    col_id: 'Product ID',
    col_title: 'Title',
    col_category: 'Category',
    col_price: 'Price',
    'col_original-stock': 'Total Stock',
    col_sold: 'Sold',
    col_stock: 'Remaining Stock',
    col_totalSale: 'Total Sale',
    col_totalRemaining: 'Total Remaining',
    col_code: 'Coupon Code',
    col_discount: 'Discount (TL)',
    col_used: 'Used',
    col_totalDiscount: 'Total Discount (TL)',
    line_affiliate: 'Affiliate Sales',
    line_sale_point: 'Sales Point Sales',
    line_promoter: 'Promoter Sales',
    line_manager_cash: 'Manager Cash',
    line_website: 'Website',
    line_mobile: 'Mobile',
    line_sale_agent: 'Sale Agent',
    line_affiliate_unbound: 'Affiliate (unbound)',
    line_sale_point_unbound: 'Sales Point (unbound)',
    line_other: 'Other',
  },
  sales: {
    title_session: 'Event Session / Sales List',
    desc_session: 'This list shows all sales for the selected event session.',
    title_event: 'Event / Sales List',
    desc_event: 'This list shows all sales for the selected event.',
    title_user: 'User / Sales List',
    desc_user: 'This list shows all sales for the selected user.',
    title_default: 'Sales List',
    desc_default:
      'This list shows the last 100 entries ordered on date/time, in order to view more and specific sales you can query them via events page.',
    detail_title: 'Sale Detail',
    sale_id: 'Sale ID',
    order_id: 'Order ID',
    sale_date: 'Sale Date',
    channel: 'Channel',
    user: 'User',
    user_email: 'Email',
    user_mobile: 'Phone',
    event: 'Event',
    payment_type: 'Payment Type',
    payment_amount: 'Payment Amount',
    payment: 'Payment',
    products_count: 'Products',
    sold_by: 'Sold By',
    status: 'Status',
    redirecting_payment: 'Redirecting to refund screen…',
    no_permission: "You don't have the right permission set to view this page.",
    status_awaiting: 'Awaiting',
    status_confirmed: 'Confirmed',
    status_failed: 'Failed',
    status_refunded: 'Refunded',
    channel_website: 'Website',
    channel_mobile: 'Mobile',
    channel_sale_point: 'Sale Point',
    channel_sale_agent: 'Sale Agent',
    channel_org_promoter: 'Org C. Promoter',
    channel_venue_promoter: 'Venue Promoter',
    channel_affiliate: 'Affiliate',
    channel_org_manager: 'Org C. Manager',
    channel_venue_manager: 'Venue Manager',
    payment_credit_card: 'Credit Card',
    payment_cash: 'Cash',
    tickets_count: '%{count} tickets',
    refund_failed: 'Refund failed',
    refund_pending: 'Refund pending',
    refund_in_progress: 'Refund in progress',
    refund_success: 'Refund successful',
    bulk_refund_title: 'Bulk Refund Actions',
    bulk_refund_start: 'Start Bulk Refund',
    search_placeholder: 'Search by event, user, email, phone, order id or channel…',
    search_placeholder_user: 'Search this user’s sales by event name, order id or channel…',
  },
  tickets: {
    title_session: 'Event Session / Tickets List',
    desc_session: 'This list shows all tickets for the selected event session.',
    title_event: 'Event / Tickets List',
    desc_event: 'This list shows all tickets for the selected event.',
    title_default: 'Tickets List',
    desc_default: 'This list shows the last 100 entries ordered on date/time.',
    no_permission: "You don't have the right permission set to view this page.",
    usage_yes: 'Yes',
    usage_no: 'No',
    refunded: 'Refunded',
    refund_pending: 'Refund pending',
    search_placeholder: 'Search by event, user name, email, phone or PNR…',
  },
  filters: {
    equals: 'Equals',
    contains: 'Contains',
    is: 'Is',
    on_or_after: 'On or after',
    on_or_before: 'On or before',
    yes: 'Yes',
    no: 'No',
    verified_is: 'Verified is',
    visible_is: 'Visible is',
    verified_q: 'Verified?',
    visible_q: 'Visible?',
    select_city: 'Select city',
    select_type: 'Select type',
    select_category: 'Select category',
    select_venue: 'Select venue',
    search_by_name: 'Search by name',
  },
  cities: {
    // CRUD
    title: 'Cities',
    new_city: 'New City',
    edit_city: 'Edit City',
    name: 'City Name',
    // slug labels (filter / cells)
    nicosia: 'Nicosia',
    famagusta: 'Famagusta',
    iskele: 'Iskele',
    kyrenia: 'Kyrenia',
    larnaca: 'Larnaca',
    lefke: 'Lefke',
    limassol: 'Limassol',
    morphou: 'Morphou',
    paphos: 'Paphos',
    turkey: 'Turkey',
  },
  event_types: {
    1: 'Standard',
    2: 'Area Layout',
    3: 'Seated',
  },
  date_types: {
    oneoff: 'Single Date',
    session: 'Sessions',
  },
  stocks: {
    title_event: 'Sessions List',
    desc_event: 'This list shows sessions ordered on date/time, for the selected event.',
    title_default: 'Sessions List',
    desc_default: 'This list shows the last 100 sessions ordered on date/time.',
    no_permission: "You don't have the right permission set to view this page.",
  },
  payments: {
    title: 'Payment Transaction Details',
    section_summary: 'Summary',
    section_card: 'Card / Transaction',
    section_refund: 'Refund status',
    status: 'Status',
    status_awaiting: 'Awaiting',
    status_confirmed: 'Confirmed',
    status_failed: 'Failed',
    status_refunded: 'Refunded',
    status_unknown: 'Unknown',
    payment_id: 'Payment ID',
    payment_amount: 'Payment Amount',
    payment_date: 'Payment Date',
    sale: 'Sale',
    event: 'Event',
    card_holder: 'Card Holder',
    card_number: 'Card Number',
    order_id: 'Order ID',
    transaction_id: 'Transaction ID',
    x_id: 'X ID',
    refunded_amount: 'Refunded Amount',
    refund_note: 'Refund Note',
    pending_refund: 'Pending Refund (Next Day)',
    refunded_at: 'Refunded At',
    error_message: 'Error Message',
    information: 'Information',
    refund_failed_warning: 'Refund failed',
    retry_limit_exceeded: ' (attempt limit exceeded)',
    will_retry: ' (will retry)',
    unknown_error: 'Unknown error',
    refund_action_title: 'Refund Action',
    refund_action_desc: 'Refunds card payment via Garanti TEST/PROD. Refundable amount:',
    make_refund: 'Refund',
    dialog_title: 'Payment Refund',
    amount_based: 'Amount based',
    product_based: 'Product based',
    refund_amount_label: 'Refund amount (TL)',
    max_label: 'Maximum:',
    same_day_garanti_warning:
      'Since this payment was made today, Garanti only accepts full refund (void). To refund a specific product, try again the next day.',
    loading_products: 'Loading products...',
    no_refundable_products: 'No refundable products found in this sale.',
    col_product: 'Product',
    col_unit: 'Unit',
    col_count: 'Count',
    selected_total: 'Selected estimated total:',
    same_day_note_footer:
      'Note: Garanti does not allow same-day partial refunds; partial/product-based refunds can be done next day.',
    cancel: 'Cancel',
    schedule_next_day: 'Schedule for next day (auto refund)',
    confirm_refund: 'Confirm Refund',
    processing: 'Processing...',
    refund_logs_title: 'Refund Logs',
  },
  notifications: {
    title: 'Notifications',
    desc: 'Legacy mobile (Gişe Expo), new mobile, and web channels.',
    tab_legacy_mobile: 'Legacy Mobile App',
    tab_new_mobile: 'New Mobile App',
    tab_web: 'Web Notification',
    legacy_token_info: 'Legacy Gişe Expo tokens:',
    legacy_token_desc:
      'Firebase `users.token` → legacy_push_tokens. Subject + body only. Select users with tokens if needed.',
    new_token_info: 'New mobile tokens:',
    new_token_desc:
      'Nest `push_tokens` (new app register). Subject + body only. Select users with tokens if needed.',
    web_live_ws: 'Live WS:',
    web_logged_in: 'Logged in:',
    web_os_push: 'OS push:',
    web_live_desc: 'Live = open tabs on site + WebSocket. Refreshes every 3 seconds.',
    target_mobile: 'Target (mobile)',
    target_web: 'Target audience (web)',
    target_all_tokens: 'All tokens',
    target_select_users_token: 'Select user (with token)',
    target_live_only: 'Only live (WS)',
    target_all_logged_in: 'All logged-in users',
    target_by_role: 'By role',
    target_select_users: 'Select user',
    role_label: 'Role',
    searching: 'Searching...',
    min_chars: 'Type at least 2 characters',
    no_user_with_token: 'No user with token found',
    no_user_found: 'No user found',
    search_user_with_token: 'Search user with token',
    search_user: 'Search user',
    search_placeholder: 'Email, name, surname...',
    mobile_token_help: 'Only users with push tokens in this app are listed',
    web_users_help: 'Will be sent to selected users',
    subject: 'Subject',
    description: 'Body / Description',
    event_optional: 'Event (optional)',
    event_optional_help: 'Opens event page when clicked',
    send_legacy_mobile: 'Send to Legacy Mobile',
    send_new_mobile: 'Send to New Mobile',
    send_web: 'Send to Web',
    confirm_send_web: '"%{title}" web notification → %{target}. Continue?',
    confirm_send_mobile: '"%{title}" %{app} → %{who}. Continue?',
    web_sent_success: 'Web sent · target %{targets} · live %{live} · OS push %{push}',
    mobile_sent_success: '%{app} mobile sent (%{sent} devices)',
    sent_failed: 'Sending failed',
  },
  users: {
    title: 'Users',
    desc: 'Search by email, phone number, or name (searches all users, not only this page).',
    search_label: 'Search',
    search_placeholder: 'Email, phone, first or last name…',
    load_error: 'Failed to load users: %{error}',
    results_count: '%{count} result(s) for “%{query}”',
    latest_count: 'Showing latest %{count} users (use search to find anyone)',
    permissions_loading: 'Loading User Permissions...',
    personal_info: 'Personal Information',
    membership_date: 'Membership Date',
    dob: 'Date of birth',
    newsletter: 'Newsletter Subscription',
    is_verified: 'Verified User',
    verification_code: 'Verification Code',
    verification_code_help:
      'When you change this code, a new verification email will be sent to the user.',
    new_password: 'New Password',
    new_password_help: 'Leave empty to keep the current password.',
    role_section: 'Role',
    role_label: 'Role',
    no_role: 'No role',
    org_company_label: 'Organisation Company',
    venue_label: 'Venue',
    email_unique_help: 'Must be unique. User will sign in with this email after save.',
    view_sales: 'View Sales',
    default_role: 'User',
    roles: {
      admin: 'Admin',
      organisationCompanyManager: 'Org Manager',
      venueManager: 'Venue Manager',
      affiliate: 'Affiliate',
      operator: 'Operator',
      editor: 'Editor',
      promoter: 'Promoter',
      user: 'User',
    },
  },
  promoters: {
    title: 'Promoters',
    user: 'User',
    mobile: 'Mobile',
    belongs_to: 'Belongs To',
    created_on: 'Created On',
    filter_org: 'Org. Company Filter',
    filter_venue: 'Venue Filter',
    company_name: 'Company Name',
    venue_name: 'Venue Name',
    user_selection: 'User Selection',
    details: 'Details',
    promoter_type: 'Promoter Type',
    type_org: 'Organisation Company',
    type_venue: 'Venue',
    please_select: 'Please Select',
    org_company: 'Organisation Company',
    venue: 'Venue',
    notes: 'Notes',
    notes_placeholder: 'Any notes related to the promoter can go here..',
  },
  saleAgents: {
    title: 'Sale Agents',
    title_applications: 'Sales Agent Applications',
    tab_list: 'Sale Agents',
    tab_applications: 'Applications',
    new_agent: 'New Sale Agent',
    edit_agent: 'Edit Sale Agent',
    name: 'Name',
    user: 'User',
    users: 'Users',
    users_count: '%{count} users',
    primary_user: 'Primary user',
    email: 'Email',
    mobile: 'Mobile',
    notes: 'Notes',
    created: 'Created',
    user_section: 'Users',
    details_section: 'Details',
    search_placeholder: 'Search by name or notes…',
    commission_rate: 'Commission Rate (%)',
    commission_rate_none: 'Not set',
    commission_rate_help: 'Optional. Enter a number only (e.g. 12.5).',
    partner_section: 'Partner Portal Assignments',
    key_website: 'Website / App Link',
    key_affiliate: 'Affiliate Code',
    key_events: 'Events',
    key_venues: 'Venues',
    key_orgs: 'Organisation Companies',
    key_address: 'Physical Address',
    website_url: 'Website or app link',
    website_url_help: 'When set, the partner feed endpoint is enabled for site integration.',
    feed_title: 'Site integration API',
    feed_help: 'Fetch partner events as JSON from this URL.',
    copy_feed: 'Copy',
    copied_feed: 'Copied',
    affiliate_code: 'Affiliate Code',
    events: 'Events',
    venues: 'Venues',
    orgs: 'Organisation Companies',
    has_physical_address: 'Has a physical address?',
    physical_address: 'Location / Address',
    physical_address_help: 'Enter address or location details',
  },
  venues: {
    title: 'Venues',
    title_applications: 'Venue Applications',
    tab_list: 'Venues',
    tab_applications: 'Applications',
    new_venue: 'New Venue',
    edit_venue: 'Edit Venue',
    basic_info: 'Basic Information',
    url_slug: 'URL Slug',
    media: 'Media',
    logo: 'Logo',
    banner: 'Banner',
    venue_layout: 'Venue Layout',
    youtube: 'Youtube',
    youtube_help: 'Please enter only the video ID (the code after ?v=) NOT the whole URL.',
    contact: 'Contact',
    about: 'About Venue',
    address_info: 'Address Information',
    city: 'City',
    address: 'Full Address',
    legal: 'Legal',
    company_type: 'Company Type',
    legal_entity: 'Legal Entity',
    legal_tax_name: 'Legal Tax Name',
    tax_document: 'Tax Document',
    financial: 'Financial',
    bank_account_name: 'Bank Account Name',
    bank_name: 'Bank Name',
    bank_iban: 'Bank IBAN Number',
    seo: 'SEO Related',
    managers: 'Managers',
    feature_button: 'Feature',
    square_img_hint: 'Square ratio images should be uploaded. Both sides should be equal.',
    landscape_img_hint: 'Landscape ratio images should be uploaded. 16:9 ratio is preferrable.',
    search_placeholder: 'Search name, slug, phone, email or address…',
  },
  organisationCompanies: {
    title: 'Organisation Companies',
    title_applications: 'Organisation Applications',
    tab_list: 'Organisation Companies',
    tab_applications: 'Applications',
    new_company: 'New Organisation Company',
    edit_company: 'Edit Organisation Company',
    company_details: 'Company Details',
    about_company: 'About Company',
    name: 'Company Name',
    phone: 'Phone',
    email: 'Email',
    managers: 'Managers',
    search_placeholder: 'Search name, slug, phone, email or address…',
  },
  layouts: {
    title: 'Layouts / Seating Plans',
    new_layout: 'New Layout',
    edit_layout: 'Edit Layout',
    name: 'Layout Name',
    venue: 'Venue',
    type: 'Type',
    seat_plan: 'Seat Plan',
    area_layout: 'Area Layout',
    firebase_temp_note: 'Temp: Overwrites Firebase layouts using same id',
    no_data_error: 'No seating plan data saved for this layout.',
  },
  seating: {
    add_seat: 'Add Seat',
    add_bg: 'Add Background (Image)',
    remove_bg: 'Remove Background (Image)',
    add_area_rect: 'Add Area (Rectangle)',
    add_area_circle: 'Add Area (Circle)',
    select_seats_assign: 'Select seats to assign a product',
    select_area_assign: 'Select an area to assign a product',
    create_seats: 'Create seats to see relevant actions',
    create_areas: 'Create areas to see relevant actions',
    selected: 'Selected:',
    seats: 'seats',
    areas: 'areas',
    area: 'area',
    create_actions: 'Create Actions:',
    delete: 'Delete',
    rename_seat_id: 'Rename Seat ID',
    assign_tickets: 'Assign Tickets:',
    ticket: 'Ticket',
    assign: 'Assign',
    remove: 'Remove',
    clone: 'Clone',
    edit_size: 'Edit Size',
    rename: 'Rename',
    bg_color: 'BG Color',
    fg_color: 'FG Color',
    selectable: 'Selectable',
    view_products: 'View Products:',
    select_one_area_view: 'Please select only one area to view products',
    select_one_area_assign: 'Please select only one area to assign products',
    no_products: 'No products assigned yet.',
    assign_products: 'Assign Products:',
    products: 'Products',
    product: 'Product',
    stats: 'Stats',
    total_seats: 'Total Seats:',
    total_areas: 'Total Areas:',
    assigned_seats: 'Assigned Seats:',
    assigned_areas: 'Assigned Areas:',
    unassigned_seats: 'Unassigned Seats:',
    unassigned_areas: 'Unassigned Areas:',
    assigned_products: 'Assigned Products/Tickets:',
    prompt_area_width: 'Please enter the width of the area',
    prompt_area_height: 'Please enter the height of the area',
    prompt_image_url: 'Please enter the URL of the image',
    prompt_clone_label: 'Enter a label for the cloned area:',
    label_exists: 'Label already exists, it must be unique',
    prompt_new_width: 'Enter new width:',
    prompt_new_height: 'Enter new height:',
    prompt_new_radius: 'Enter new radius:',
    prompt_seat_id: 'Enter new ID for the seat:',
    id_unique: 'ID must be unique.',
    prompt_color: 'Enter new color:',
    select_product_first: 'Please select a product first. If there is none, add a new product.',
  },
  salePoints: {
    title: 'Sale Points',
    new_salepoint: 'New Sale Point',
    edit_salepoint: 'Edit Sale Point',
    name: 'Sale Point Name',
    telephone: 'Telephone',
    description: 'Description',
    city: 'City',
    address: 'Address',
    longitude: 'Longitude',
    latitude: 'Latitude',
    photo_logo: 'Photo (Logo)',
    payment_methods: 'Payment Methods',
    active_filter: 'Active Filter',
    show_on_website: 'Show sale point on website',
    save_notice: 'Please note that the sale point should be saved for this change to take effect.',
    method_cc: 'Credit Card',
    method_cash: 'Cash',
    method_btc: 'Bitcoin',
    method_transfer: 'Wire Transfer / EFT',
  },
  categories: {
    title: 'Categories',
    new_category: 'New Category',
    edit_category: 'Edit Category',
    name: 'Category Name',
    active: 'Active?',
    order: 'Order',
    active_help: 'If you want to deactivate this category, please uncheck this field.',
    order_help: 'Please enter a number to determine the order of the category.',
    icon: 'Icon',
    icon_hint:
      'Leave empty to keep the default site icon. Upload to override. Square (1:1) recommended.',
    icon_crop_title: 'Crop Category Icon (1:1)',
    icon_crop_desc: 'Crop area is locked to a square ratio.',
    yes: 'Yes',
    no: 'No',
  },
  subcategories: {
    title: 'Sub Categories',
    new_subcategory: 'New Sub Category',
    edit_subcategory: 'Edit Sub Category',
    name: 'Sub Category Name',
    category: 'Parent Category',
  },
  venueCategories: {
    title: 'Venue Categories',
    new_category: 'New Venue Category',
    edit_category: 'Edit Venue Category',
    name: 'Category Name',
  },
  news: {
    title: 'Blogs',
    new_news: 'New Blog',
    edit_news: 'Edit Blog',
    news_title: 'Title',
    subtitle: 'Sub Title',
    content: 'Content',
    date: 'Date',
    banner: 'Blog Banner',
    created: 'Created Date',
    updated: 'Last Updated',
  },
  pages: {
    title: 'Static Pages',
    edit_page: 'Edit Page',
    page_title: 'Page Title',
    content: 'Content',
  },
  heros: {
    title: 'Home Special Event Hero',
    bg_image: 'Hero Background Image',
    banner_crop_hint: 'Home hero size 1920×504. Crop before saving.',
    banner_crop_title: 'Crop Image (1920×504)',
    banner_crop_desc: 'Crop area is locked to the home hero ratio. Drag and resize the selection.',
    featured_image: 'Featured image (optional — falls back to event banner)',
    featured_crop_hint: 'Hero card size 275×344. Crop before saving.',
    featured_crop_title: 'Crop Image (275×344)',
    featured_crop_desc:
      'Crop area is locked to the hero card ratio. Drag and resize the selection.',
    record: 'Record',
    last_updated: 'Last Updated',
    empty_msg: 'No hero record found. Create one with ID: home.',
  },
  homeSections: {
    title: 'Home Sections',
    new_section: 'New Home Section',
    edit_section: 'Edit Home Section',
    main_details: 'Main Details',
    content: 'Content',
    order: 'Order',
    title_tr: 'Title (TR)',
    title_en: 'Title (EN)',
    is_featured: 'Featured section model? (custom image + price button)',
    featured_help: 'Featured: Card button shows lowest price of active items instead of "Buy".',
    fetch_upcoming_venue: 'Fetch upcoming events of this venue? (without manual selection)',
    fetch_upcoming_category: 'Show upcoming events of the category?',
  },
  featureds: {
    title: 'Featured List Settings',
    new_featured: 'New Featured Record',
    edit_featured: 'Edit Featured Record',
    venues: 'Venues',
  },
  groupEvents: {
    title: 'Group Events',
    new_group: 'New Group Event',
    edit_group: 'Edit Group Event',
    basic_details: 'Basic Details',
    name: 'Group Name',
    start_date: 'Start Date',
    end_date: 'End Date',
    description: 'Description',
    multiple_venues: 'Does this group event happen in multiple venues?',
    multiple_venues_help: 'Only switch to on (true) if there are multiple venues involved.',
    num_events: '# of Events',
    homepage_categories: 'Homepage Display Categories',
    homepage_categories_help:
      'The categories that this group event will be displayed on the website and application homepage.',
    select_categories: 'Select Categories',
    video_id: 'Video ID (YouTube ID)',
    select_events: 'Select Events',
    loading_upcoming: 'Loading upcoming events…',
    load_error: 'Could not load events: %{error}. Check API is running.',
    no_upcoming: 'No upcoming active events found. Create or activate events first.',
  },
  event_status: {
    cancelled: 'Cancelled',
    pending: 'Pending',
    upcoming: 'Upcoming',
    active: 'Happening now!',
    ended: 'Recently Ended',
    ended_short: 'Ended',
    unknown: 'Unknown',
  },
  affiliates: {
    title: 'Affiliates',
    new_affiliate: 'Create Affiliate',
    edit_affiliate: 'Edit Affiliate',
    details: 'Affiliate Details',
    name: 'Name',
    code: 'Affiliate Code',
    search_code: 'Search AF Code',
    created: 'Created',
    search_placeholder: 'Search by name or AF code…',
    pull_firebase: 'Pull from Firebase (Postgres)',
    pulling: 'Pulling…',
    pull_confirm: 'Import all Firebase affiliate records into Postgres?',
    pull_ok: 'Pull OK: {{affiliates}} affiliates, {{users}} users',
    pull_partial: '{{count}} records failed (see console)',
    pull_error: 'Pull error: {{message}}',
  },
  systemParameters: {
    title: 'System Parameters',
    edit_title: 'Edit System Parameters',
    system_settings: 'System Settings',
    admin_phone: 'Admin Phone Number',
    variables: 'Variables',
    default_service_fee: 'Default Service Fee',
    default_commission_fee: 'Default Commission Fee',
  },
  appVersionConfigs: {
    title: 'App Version Control',
    platform: 'Platform',
    latest_version: 'Latest Version',
    minimum_version: 'Minimum Version',
    force_update: 'Force Update',
    maintenance: 'Maintenance Mode',
    store_url: 'Store URL',
    maintenance_message: 'Maintenance Message',
    release_notes: 'Release Notes (One item per line)',
    latest_help: 'e.g. 2.4.0 — latest store version',
    min_help: 'Versions below this cannot use the app',
    force_help: 'If enabled and user is below latest version, force update is shown',
  },
  deleteUserRequests: {
    title: 'Delete User Requests',
    search_placeholder: 'Email, name or phone',
    name: 'Name',
    email: 'Email',
    mobile: 'Mobile',
    reason: 'Reason',
    requested_at: 'Requested At',
    open_user: 'Open User',
    opening: 'Opening…',
    open_ok: 'User restored (DB + Firebase)',
    open_ok_no_firebase_doc: 'User restored (no Firestore document)',
    open_partial: 'DB restored; Firebase write failed: %{reason}',
    open_fail: 'Could not restore user',
    reasons: {
      another_account: 'I have another account',
      privacy_concerns: 'I have privacy concerns',
      unused_account: 'I have inactive or unused account',
      other_reason: 'I have another reason',
    },
  },
  affiliateForm: {
    title: 'Affiliate Applications',
    edit_title: 'Edit Affiliate Application',
    app_name: 'Application Name',
    app_surname: 'Application Surname',
    user: 'User',
    user_mobile: 'User Mobile',
    checked: 'Checked?',
    actions: 'Actions',
    notes: 'Notes',
    details: 'Application Details',
  },
  scripts: {
    title: 'Scripts Management',
    new_script: 'New Script',
    edit_script: 'Edit Script',
    name: 'Script Name',
    order: 'Order',
    active: 'Active?',
    content: 'Script Content',
    helper_text:
      'Paste the full script snippet (including <script> tags if needed). All attributes such as data-key are preserved.',
  },
  eventCreationApplications: {
    title: 'Applications',
    title_venue: 'Venue Applications',
    title_org: 'Organisation Applications',
    title_sales: 'Sales Agent Applications',
    application_detail: 'Application Detail',
    review_application: 'Review Application',
    approved: 'Approved',
    pending: 'Pending',
    organiser: 'Organiser',
    venue: 'Venue',
    sales_agent: 'Sales Agent',
    summary: 'Summary',
    company_info: 'Company Information',
    basic_info: 'Basic Information',
    contact: 'Contact',
    about_venue: 'About Venue',
    about_company: 'About Company',
    media: 'Media',
    address: 'Address',
    legal: 'Legal',
    financial: 'Financial',
    seo: 'SEO',
    review_add_note: 'Review / Add Note',
    categories: 'Categories',
    amenities: 'Venue Amenities',
    actions: 'Actions',
    application_type: 'Application Type',
    details: 'Details',
  },
  'resources.users.fields.name': 'Name',
  'resources.users.fields.surname': 'Surname',
  'resources.users.fields.email': 'Email',
  'resources.users.fields.mobile': 'Mobile',
  'resources.users.fields.crole': 'Role',
  'resources.users.fields.createdate': 'Registration Date',
  'resources.users.fields.gender': 'Gender',
  'resources.users.fields.country': 'Country',
  'resources.users.fields.city': 'City',
  'resources.users.fields.dob': 'Date of Birth',
  'resources.users.fields.newsletter': 'Newsletter',
  'resources.users.fields.isVerified': 'Verified',
  'resources.users.fields.verificationCode': 'Verification Code',
  'resources.promoters.fields.user': 'User',
  'resources.promoters.fields.mobile': 'Mobile',
  'resources.promoters.fields.organisationCompanies': 'Organisation Company',
  'resources.promoters.fields.venues': 'Venue',
  'resources.promoters.fields.createdate': 'Created Date',
  'resources.saleAgents.fields.name': 'Agent Name',
  'resources.saleAgents.fields.user': 'User',
  'resources.saleAgents.fields.notes': 'Notes',
  'resources.saleAgents.fields.createdate': 'Created Date',
  'resources.saleAgents.fields.commissionRate': 'Commission Rate',
  'resources.venues.fields.id': 'ID',
  'resources.venues.fields.name': 'Venue Name',
  'resources.venues.fields.categories': 'Categories',
  'resources.venues.fields.managers': 'Managers',
  'resources.venues.fields.city': 'City',
  'resources.organisationCompanies.fields.id': 'ID',
  'resources.organisationCompanies.fields.name': 'Company Name',
  'resources.organisationCompanies.fields.managers': 'Managers',
  'resources.layouts.fields.id': 'ID',
  'resources.layouts.fields.name': 'Layout Name',
  'resources.layouts.fields.venue': 'Venue',
  'resources.layouts.fields.layoutType': 'Layout Type',
  'resources.salePoints.fields.id': 'ID',
  'resources.salePoints.fields.name': 'Sale Point Name',
  'resources.salePoints.fields.city': 'City',
  'resources.salePoints.fields.isActive': 'Is Active?',
  'resources.salePoints.fields.managers': 'Managers',
  'resources.events-v2.fields.id': 'ID',
  'resources.events-v2.fields.name': 'Event Name',
  'resources.events-v2.fields.type': 'Type',
  'resources.events-v2.fields.venue': 'Venue',
  'resources.events-v2.fields.city': 'City',
  'resources.events-v2.fields.category': 'Category',
  'resources.events-v2.fields.startdate': 'Start Date',
  'resources.events-v2.fields.enddate': 'End Date',
  'resources.events-v2.fields.isVerified': 'Verified / Live',
  'resources.events-v2.fields.totalRevenue': 'Total Revenue',
  'resources.events-v2.fields.status': 'Status',
  'resources.sales.fields.id': 'ID',
  'resources.sales.fields.user.name': 'User',
  'resources.sales.fields.userName': 'User',
  'resources.sales.fields.createdate': 'Sale Date',
  'resources.sales.fields.event.name': 'Event Name',
  'resources.sales.fields.eventName': 'Event Name',
  'resources.sales.fields.userMobile': 'User Mobile',
  'resources.sales.fields.channel': 'Channel',
  'resources.sales.fields.soldBy': 'Sold By',
  'resources.sales.fields.payment': 'Payment (₺)',
  'resources.sales.fields.paymentType': 'Payment Type',
  'resources.sales.fields.oid': 'Order ID',
  'resources.sales.fields.productsCount': '# Products',
  'resources.sales.fields.product': 'Product',
  'resources.sales.fields.coupon': 'Coupon',
  'resources.sales.fields.status': 'Status',
  'resources.sales.fields.actions': 'Refund Request / Status',
  'resources.sales.fields.isNewRegistrationSale': 'New Registration (Last 7 Days)',
  'resources.sales.fields.pendingRefund': 'Refund Status',
  'resources.sales.fields.deleteButton': 'Delete',
  'resources.tickets.fields.id': 'ID',
  'resources.tickets.fields.pnr': 'PNR',
  'resources.tickets.fields.print': 'Print Ticket',
  'resources.tickets.fields.channel': 'Sale Channel',
  'resources.tickets.fields.userName': 'User',
  'resources.tickets.fields.eventName': 'Event Name',
  'resources.tickets.fields.created': 'Sale Date',
  'resources.tickets.fields.product': 'Product',
  'resources.tickets.fields.productKey': 'Product Key',
  'resources.tickets.fields.isUsed': 'Is Used?',
  'resources.tickets.fields.refund': 'Refund',
  menu: {
    dashboard: 'Dashboard',
    events_v2: 'Events (v2)',
    new_event: 'New Event',
    upcoming_events: 'Upcoming Events',
    past_events: 'Past Events',
    group_events: 'Group Events',
    notifications: 'Notifications',
    sales: 'Sales',
    tickets: 'Tickets',
    refund_requests: 'Refund Requests',
    people: 'People & Users',
    users: 'Users',
    affiliates: 'Affiliates',
    sale_agents: 'Sale Agents',
    promoters: 'Promoters',
    affiliate_form: 'Affiliate Applications',
    delete_requests: 'Delete Requests',
    places: 'Places & Venues',
    venues: 'Venues',
    layouts: 'Layouts',
    layouts_v2: 'Layouts v2',
    org_companies: 'Org. Companies',
    sale_points: 'Sale Points',
    definitions: 'Definitions',
    featured: 'Featured',
    categories: 'Categories',
    subcategories: 'Sub Categories',
    venue_categories: 'Venue Categories',
    cities: 'Cities',
    website: 'Website Management',
    home_sections: 'Home Sections',
    hero_banner: 'Home Special Event Hero',
    pages: 'Pages',
    news: 'Blogs',
    scripts: 'Scripts',
    accountancy: 'Accountancy',
    accountancy_items: 'Accountancy Items',
    mobile_app: 'Mobile App',
    app_version: 'Version Control',
    super_admin: 'Super Admin',
    deepl_settings: 'DeepL Settings',
    parameters: 'System Parameters',
    cron_logs: 'Cron Logs',
    v1_archive: 'Event V1 Archive',
    session_events_archive: 'Session Events Archive',
    advertising: 'Advertising',
    ad_packages: 'Ad Packages',
    ad_applications: 'Ad Applications',
    popup_ads: 'Popup Ads',
    utility_bar: 'Utility Bar',
    content: 'Content',
  },
  adPackages: {
    title: 'Ad Packages',
    create_title: 'New Package',
    edit_title: 'Edit Package',
    form_heading: 'Ad Package',
    form_subheading: 'Select or create a type first, then fill package details.',
    name: 'Package Name',
    type: 'Type',
    type_section_title: 'Package Type',
    type_section_desc: 'Pick one type for this package (no multi-select).',
    existing_types: 'Existing types',
    type_placeholder: 'Select a type…',
    type_single_hint: 'Only one type per package.',
    new_type: 'Create new type',
    new_type_placeholder: 'e.g. story, sidebar, newsletter…',
    add_type: 'Add type',
    selected_type: 'Selected: %{name}',
    type_required: 'Please select or create a package type.',
    type_helper: 'Pick an existing type or type a new one and press Enter to create it.',
    create_type: 'Create type "%{item}"',
    details_section_title: 'Package Details',
    details_section_desc: 'Name, price and visibility for this ad package.',
    description: 'Description',
    price: 'Price',
    currency: 'Currency',
    duration_days: 'Duration (days)',
    order: 'Order',
    is_active: 'Active?',
    types: {
      meta: 'Meta Ads',
      site: 'Site Banner',
      popup: 'Popup',
      featured: 'Featured',
      homepage: 'Homepage',
    },
  },
  adApplications: {
    title: 'Ad Applications',
    detail: 'Ad Application',
    company: 'Company',
    package: 'Package',
    package_type: 'Package Type',
    preferred_start: 'Preferred Start',
    budget: 'Budget',
    message: 'Message',
    review: 'Review Application',
  },
  'resources.adPackages.name': 'Ad Package |||| Ad Packages',
  'resources.adApplications.name': 'Ad Application |||| Ad Applications',
  'resources.popupAds.name': 'Popup Ad |||| Popup Ads',
  popupAds: {
    title: 'Popup Ads',
    create_title: 'New Popup',
    edit_title: 'Edit Popup',
    form_heading: 'Popup Ad',
    form_subheading:
      'Set banner, title, events and which pages it appears on. Preview updates live.',
    name: 'Internal Name',
    name_helper: 'Only visible in the panel list',
    order: 'Order',
    is_active: 'Active?',
    dismiss_hours: 'Hide after close (hours)',
    dismiss_helper: 'After the user closes, hide for this many hours',
    countdown_heading: 'Top Bar Countdown',
    countdown_subheading:
      'Set the end date and how many minutes before it should appear. When active, the popup floating icon grows upward and counts down.',
    countdown_ends_at: 'Countdown end date / time',
    countdown_ends_helper: 'Countdown hits zero at this moment',
    countdown_show_minutes: 'Show countdown N minutes before',
    countdown_show_helper: 'e.g. 120 → popup icon countdown appears 2 hours before end',
    banner: 'Top Banner Image',
    banner_hint: 'Recommended size 720×200. Crop before saving.',
    launcher_image: 'Popup Floating Icon Image',
    launcher_hint:
      'Square image for the popup round icon (256×256). When countdown is active the icon grows upward and counts.',
    title_field: 'Title',
    title_color: 'Title Color',
    subtitle: 'Subtitle',
    subtitle_color: 'Subtitle Color',
    footer_note: 'Footer note (fine print)',
    pages: 'Pages to show on',
    pages_helper: 'Pick “All pages” to show site-wide',
    events: 'Events (Slider)',
    event: 'Event',
    preview: 'Preview',
    preview_hint: 'On the web, cards use your event card design in a slider.',
    preview_title_placeholder: 'Title goes here',
    preview_subtitle_placeholder: 'Subtitle goes here',
  },
  'resources.utilityBarItems.name': 'Utility Bar Item |||| Utility Bar',
  'resources.loyaltyMobileApps.name': 'Loyalty App |||| Loyalty Apps',
  'resources.loyaltyMobileAppsPage.name': 'Loyalty Page Heading |||| Loyalty Page Heading',
  utilityBarItems: {
    title: 'Utility Bar',
    create_title: 'New Utility Bar Item',
    edit_title: 'Edit Utility Bar Item',
    form_heading: 'Utility Bar Item',
    form_subheading: 'Top strip links on the website. Manage icon, text and hover color here.',
    name: 'Internal Name',
    name_helper: 'Only visible in the panel list',
    order: 'Order',
    is_active: 'Active?',
    icon: 'Icon',
    icon_hint: 'Square (1:1) icon recommended. Crop before saving.',
    icon_crop_title: 'Crop Icon (1:1)',
    icon_crop_desc: 'Crop area is locked to a square ratio.',
    title_field: 'Title',
    subtitle: 'Subtitle',
    href: 'Link (URL)',
    href_helper: 'e.g. https://kuponkibris.com',
    hover_color: 'Hover Color',
    preview: 'Preview',
    preview_title: 'Title',
    preview_subtitle: 'Subtitle',
  },
  loyaltyMobileApps: {
    title: 'Loyalty Apps',
    create_title: 'New Loyalty App',
    edit_title: 'Edit Loyalty App',
    form_heading: 'Loyalty App',
    form_subheading:
      'Loyalty cards in the mobile app. Manage image, text, category and store links here.',
    tab_apps: 'Apps',
    tab_heading: 'Page Heading',
    name: 'Internal Name',
    name_helper: 'Only visible in the panel list',
    order: 'Order',
    is_active: 'Active?',
    image: 'Cover Image',
    image_hint: 'Square (1:1) cover recommended. Accent gradient is used if empty.',
    image_crop_title: 'Crop Cover (1:1)',
    image_crop_desc: 'Crop area is locked to a square ratio.',
    accent_color: 'Accent Color',
    title_field: 'Title',
    subtitle: 'Subtitle',
    category: 'Category',
    category_helper: 'Badge in the top-left of the card',
    ios_store_url: 'App Store URL',
    ios_store_helper: 'Opens on iOS devices',
    android_store_url: 'Play Store URL',
    android_store_helper: 'Opens on Android devices',
    preview: 'Preview',
    preview_title: 'Title',
    preview_subtitle: 'Subtitle',
    preview_download: 'Download',
  },
  loyaltyMobileAppsPage: {
    edit_title: 'Loyalty Page Heading',
    form_heading: 'Loyalty Apps Page',
    form_subheading: 'Heading shown above the loyalty apps list in the mobile app.',
    heading: 'Page Heading',
  },
  errors: {
    admin_only: 'Only admin can access this page.',
  },
  deepl: {
    title: 'DeepL Auto Translation',
    subtitle:
      'Manage API key, plan and target languages. Events, group events, categories and venues are auto-translated on save.',
    api_key_title: 'API Key',
    api_key_desc: 'Enter your API key obtained from your DeepL account',
    api_key_placeholder: 'Your DeepL API Key...',
    api_key_valid: 'API key is valid',
    api_key_invalid: 'API key is invalid or missing',
    api_plan: 'API Plan',
    usage_info: 'Usage: %{count} / %{limit} characters',
    save_button: 'Save',
    test_button: 'Test Connection',
    languages_title: 'Translation Languages',
    languages_desc: 'Select and manage which languages to auto-translate to',
    select_language: 'Select language...',
    add_language: 'Add',
    active: 'Active',
    passive: 'Inactive',
    total_languages: 'Total %{total} languages • %{active} active',
    no_languages: 'No languages yet. Pick one above to start auto-translation.',
    auto_translate_info:
      'Auto-translation active. New and updated content will be translated to this language.',
    auto_translate_off: 'Auto-translation disabled.',
    connection_success: 'DeepL API connection successful!',
    connection_failed: 'DeepL API connection failed!',
    saved_success: 'DeepL settings saved successfully.',
  },
  form: {
    source_language_title: 'Source Language:',
    source_language_desc:
      'Write in this language; others are translated via DeepL. Change language from the navbar.',
    source_language_locked_desc:
      "This record's source language is locked (%{lang}). Auto-translations are based on this language.",
    basic_details: 'Basic Details',
    date_details: 'Date Details',
    more_details: 'Description & Rules',
    visuals: 'Visuals',
    products: 'Products & Stocks',
    layout: 'Layout',
    venue_required_for_layouts:
      'Select a venue in the Basic Details section to see available layouts.',
    select_area_layout:
      'Please select an AREA layout for the chosen venue. If none exist, create one in the Layouts module.',
    select_seating_layout:
      'Please select a SEATING layout for the chosen venue. If none exist, create one in the Layouts module.',
    no_assigned_seats_warning:
      'No saved seat assignments found — base layout opened. Assign products to seats and save again.',
    layout_save_failed:
      'Seat plan could not be saved: %{error}. (If API 413, body limit deploy is required)',
    layout_empty_warning:
      'Layout selected but seat plan is empty — open the Layout tab and try again',
    coupons: 'Coupons',
    fees: 'Fees & Commissions',
    settings: 'Settings & Status',
    event_description: 'Event Description',
    required_mark: '*required',
    description: 'Description',
    description_tr: 'Description (Turkish)',
    description_en: 'Description (English)',
    event_rules: 'Event Rules',
    event_rules_tr: 'Event Rules (Turkish)',
    event_rules_en: 'Event Rules (English)',
    things_to_know: 'Things to know',
    rule_chips: 'Rule Chips',
    rule_chips_hint: "Rules that are left empty won't appear on the front-end website.",
    age_rule: 'Age Rule',
    show_event_on_website: 'Show this event on the website?',
    verified_event: 'Verified Event?',
    homepage_visibility: 'Homepage Visibility',
    hide_from_web_home: 'Hide from web homepage',
    hide_from_web_home_hint: "If enabled, this event won't appear on the web homepage sections.",
    hide_from_mobile_home: 'Hide from mobile homepage',
    hide_from_mobile_home_hint:
      "If enabled, this event won't appear on the mobile homepage sections.",
    auto_urgency_badges: 'Automatic Urgency Badges',
    urgency_hint: 'Displays a single red badge on card. Priority: hours → tickets → days.',
    pre_selected_types: 'Pre Selected Types',
    event_name: 'Event Name',
    unique_event_slug: 'Unique Event Slug',
    organisation_company: 'Organisation Company',
    event_badge: 'Event Badge',
    badge_label: 'Badge Label',
    label_color: 'Label Color',
    background_color: 'Background Color',
    payment_methods: 'Payment Methods',
    reset_confirm: 'Are you sure you want to reset the form?',
    category: 'Category',
    subcategories: 'Sub Categories',
    venue: 'Venue',
    city: 'City',
    event_start_date: 'Event Start Date',
    event_duration: 'Event Duration (minutes)',
    event_end_date: 'Event End Date',
    end_date_auto_calc: 'Automatically calculated from start + duration.',
    end_date_hint: 'Appears here when start date and duration are set.',
    search_placeholder: 'Search by name, slug, venue, city, category or subcategory…',
    search_user_placeholder: 'Search by email or name...',
    user_already_selected: 'User already selected',
    search_prompt: 'Enter email or name to search',
    user_search_failed: 'User search failed',
    loading_user: 'Loading user…',
    change_user: 'Change user',
    search_results: 'Search results',
    no_users_found: 'No users found. Try email or part of name.',
    chosen_users: 'Chosen User(s)',
    visual_poster: 'Visual / Poster',
    visual_poster_hint: 'Portrait images with 4:5 ratio (1080 x 1350) should be uploaded.',
    poster_crop_hint:
      'Poster images with 4:5 ratio (1080×1350) are recommended. Check the preview before saving.',
    visual_design1: 'Design 1 Image (Card / Detail)',
    visual_design1_hint: 'Landscape 344×194. Home design 1 card and event detail.',
    design1_crop_hint: 'Design 1 is 344×194. Crop before saving.',
    design1_crop_title: 'Crop Image (344×194)',
    design1_crop_desc: 'Crop area is locked to design 1 ratio.',
    visual_design2: 'Design 2 Image (List / Poster)',
    visual_design2_hint: 'Portrait 4:5 (1080×1350). Home design 2 list and poster.',
    design2_crop_hint: 'Design 2 is 4:5 (1080×1350). Crop before saving.',
    design2_crop_title: 'Crop Image (4:5)',
    design2_crop_desc: 'Crop area is locked to design 2 (4:5) ratio.',
    event_video: 'Event Video',
    video_hint:
      'Please note that the entry should only contain the ID (the code after ?v=) of the video NOT the whole URL.',
    video_label: 'Video ID (Youtube ID)',
    venue_layout: 'Venue Layout Image',
    layout_desc:
      'Upload if there is a specific layout for this event. If not, the default layout for the venue will be used.',
    layout_hint: 'Square ratio images should be uploaded. Both sides should be equal.',
    change_image: 'Change Image',
    add_image: 'Add Image',
    remove: 'Remove',
    crop_image_title: 'Crop Image (4:5)',
    crop_image_desc: 'Crop area is locked to 4:5 ratio. Drag and resize the selection area.',
    cropping: 'Processing…',
    apply_crop: 'Crop & Apply',
    payment_method_cc: 'Credit Card',
    payment_method_doorcash: 'Cash At Door',
    slug_helper_text:
      'Unique URL slug: only lowercase a-z, 0-9 and hyphens. No Turkish characters.',
    dress_code: 'Dress Code',
    dress_code_1: 'Casual',
    dress_code_2: 'Come as you are',
    dress_code_3: 'Elegant',
    dress_code_4: 'Smart Casual',
    dress_code_5: 'No Dress Code',
    couples_rule: 'Couples Rule',
    couples_rule_1: 'No Rules',
    couples_rule_2: 'Men have to be with women',
    special_deal: 'Special Deal Tickets',
    reservation: 'Reservation / Pre-sale',
    general_ticket: 'General Tickets',
    vip_list: 'VIP Tickets',
    extras: 'Extra Items',
    invitations: 'Invitations',
    invitations_hint: 'Can create invitations for guests to attend the event.',
    all_fields_required: '(* all fields required)',
    title: 'Title',
    title_tr: 'Turkish Title',
    title_en: 'English Title',
    price: 'Ticket Price',
    price_change_hint:
      'If you need to change the price of a product, you can do so by creating a new product and hiding the old one.',
    sold: 'Sold',
    ticket_stock: 'Stock',
    status: 'Status',
    promotion_available: 'Promotion Available?',
    promotion_label: 'Promotion Label',
    promotion_price: 'Promotion Price',
    total_stock: 'Total Stock',
    total_sold: 'Total Sold (For this session)',
    refundable: 'Refundable?',
    has_down_payment: 'Has Down Payment?',
    down_payment_price: 'Down Payment Price',
    has_basket_limit: 'Has Basket Limit?',
    basket_limit: 'Basket Limit',
    ticket_status: 'Ticket Status',
    status_0: 'On Sale',
    status_1: 'Sold Out',
    status_2: 'Hidden',
    tickets: 'Tickets',
    coupons: 'Coupons',
    coupon_code: 'Coupon Code',
    discount_tl: 'Discount (TL)',
    stock: 'Coupon Stock',
    activeUntil: 'Active Until',
    active_until: 'Active Until',
    active_until_after_today: 'Active until date should be after today.',
    active_until_before_start: 'Active until date should be before the event start date.',
    system_params_error: 'System parameters could not be loaded. Please report this before saving.',
    service_fee: 'Event Service Fee (TL)',
    service_fee_hint: 'Service fee to cover extra operational cost.',
    commission_fee: 'Event Commission Fee (%)',
    commission_fee_default_hint: 'Default from system parameters: %{fee}%',
    is_commission_extra: 'Is commission extra (added to ticket prices)?',
    is_commission_extra_hint:
      'Please note that the prices for the event will change if this is turned on.',
    urgency_hours_label: 'Show badge when N hours remain',
    urgency_hours_threshold: 'N hours (threshold)',
    urgency_tickets_label: 'Show badge when N tickets remain',
    urgency_tickets_threshold: 'N tickets (threshold)',
    urgency_days_label: 'Show badge when N days remain',
    urgency_days_threshold: 'N days (threshold)',
    hours_threshold_required: 'Hours threshold is required.',
    valid_number_required: 'Enter a valid number.',
    hours_threshold_min: 'Hours threshold must be at least 1.',
    hours_threshold_max: 'Hours threshold can be at most %{max}.',
    hours_threshold_hint:
      'Shows "Last N hours" badge when remaining hours is less than or equal to this.',
    tickets_threshold_required: 'Tickets threshold is required.',
    tickets_threshold_min: 'Tickets threshold must be at least 1.',
    tickets_threshold_max: 'Tickets threshold can be at most %{max}.',
    tickets_threshold_hint:
      'Shows "Last N tickets" badge when remaining tickets is less than or equal to this.',
    days_threshold_required: 'Days threshold is required.',
    days_threshold_min: 'Days threshold must be at least 1.',
    days_threshold_max: 'Days threshold can be at most %{max}.',
    days_threshold_hint:
      'Shows "Last N days" badge when remaining days is less than or equal to this.',
    refund_settings: 'Refund Settings',
    refund_enabled: 'Accept refund requests?',
    refund_enabled_hint: 'If disabled, users cannot request refunds for this event via website.',
    refund_deadline: 'Refund Deadline Date/Time',
    refund_deadline_error: 'Refund deadline cannot be after the event start date.',
    refund_deadline_hint:
      'Users can request refunds up to this date and time. Leave empty for no limit.',
    refund_deadline_startdate_hint: 'Set event start date first, then configure refund deadline.',
    show_event_on_website: 'Show this event on the website',
    is_active_hint: "Please note that the event should be 'saved' for this change to take effect.",
    verified_event: 'Verified Event?',
    is_verified_hint: 'Is event verified by the admin?',
    select_organisation_company: 'Select organisation company…',
    select_venue: 'Select venue…',
    select_category: 'Select category…',
    select_subcategory: 'Select subcategory…',
  },
  show: {
    details: 'Details',
    start: 'Start',
    end: 'End',
    sessions: 'Sessions',
    sessions_detail: '%{length} sessions (%{duration} minutes each)',
    verified: 'Verified',
    verified_yes: '✅ Yes - Showing up on the website and mobile application.',
    verified_no:
      '❌ No - Awaiting to be verified to be shown on the website and the mobile application.',
    active: 'Active',
    active_yes: '✅ Yes - Event is live and can be purchased.',
    active_no: '❌ No - Event is not live and cannot be purchased.',
    event_link: 'Event Link (Preview)',
    sales_summary: 'Sales Summary',
    loading_sales_summary: 'Loading sales summary…',
    transformed_summary_hint:
      'Please note that the sales summary is not available for the transformed events, please check sales report for more details.',
    total_product_sales: 'Total Product Sales',
    total_sales_tickets: 'Total Sales / Tickets',
    total_seats: 'Total Seats',
    sales_reports: 'Sales & Reports',
    sale_report: 'Sale Report',
    view_all_sales: 'View All Sales',
    view_all_tickets: 'View All Tickets',
    actions: 'Actions',
    view_sessions: 'View Sessions',
    edit_event: 'Edit Event',
    seat_ops: 'Seat Ops',
    cancel_event: 'Cancel Event',
    clone_event: 'Clone Event',
    cloning: 'Cloning...',
    homepage_visibility: 'Homepage Visibility',
    show_on_web: 'Show on Web',
    hide_on_web: 'Hide on Web',
    show_on_mobile: 'Show on Mobile',
    hide_on_mobile: 'Hide on Mobile',
    home_placements: 'Homepage Placements',
    home_placements_title: 'Homepage Placements',
    home_placements_desc:
      'Choose which homepage sections this event appears in. You can select multiple sections.',
    home_placements_selected_count: '%{count} placements selected',
    home_placements_hero: 'Homepage Special Event Hero',
    home_placements_no_sections:
      'No assignable special sections. Sections with a category selected are not listed here.',
    home_placements_manual: 'Manual event list',
    home_placements_auto: 'Auto upcoming (switches to manual when added)',
    home_placements_has_image: 'Custom image selected',
    home_placements_selected: 'Selected',
    home_placements_optional_image: 'Custom image optional',
    home_placements_featured_badge: 'Featured',
    home_placements_featured_hint: 'Selecting asks for an optional custom image.',
    home_placements_auto_short: 'Auto → manual',
    home_placements_ask_image_title: 'Upload a custom image?',
    home_placements_ask_image_desc:
      'If you skip, the event banner is used. Size matches the hero card (275×344).',
    home_placements_skip_image: 'No, add without image',
    home_placements_yes_image: 'Yes, upload image',
    home_placements_image_editor_title: 'Custom image',
    home_placements_or_url: 'or image URL',
    home_placements_use_url: 'Use',
    home_placements_saved: 'Homepage placements saved.',
    pull_firebase: 'Pull Latest (Firebase)',
    pulling: 'Pulling…',
    error_loading_event_data: 'Error loading event data',
    delete_event: 'Delete Event',
    checking_sales: 'Checking sales…',
    delete_event_desc:
      'Choose how to remove this event. Soft delete keeps all data and hides the event from the panel and website.',
    cannot_verify_sales_warning:
      'Could not verify sales. Permanent delete is disabled until sales are checked.',
    has_sales_warning: 'This event has %{count} completed sale(s). Only soft delete is available.',
    no_sales_notice: 'No completed ticket sales found. You can soft delete or permanently delete.',
    working: 'Working…',
    soft_delete: 'Soft Delete',
    delete_permanently: 'Delete Permanently',
    hard_delete_confirm:
      'This will permanently delete the event and its stock data. This cannot be undone. Continue?',
    could_not_verify_sales: 'Could not verify sales for this event.',
    event_permanently_deleted: 'Event permanently deleted.',
    event_soft_deleted: 'Event hidden (soft delete).',
    failed_to_delete_event: 'Failed to delete event.',
  },
  list: {
    all_events: 'All Events',
    upcoming_events: 'Upcoming Events',
    pending_events: 'Pending Events',
    cancelled_events: 'Cancelled Events',
    all_events_desc:
      'Upcoming events: published, pending and cancelled. Past events are not listed here.',
    upcoming_events_desc: 'Published upcoming events that have not yet passed.',
    pending_events_desc: 'Upcoming events not yet published on the website.',
    cancelled_events_desc: 'Cancelled events that have not yet passed.',
    view: 'View',
    view_all: 'All',
    view_upcoming: 'Upcoming',
    view_pending: 'Pending',
    view_cancelled: 'Cancelled',
    no_permission: "You don't have the right permission set to view this page.",
    pull_firebase_all: 'Pull All from Firebase',
    pulling_firebase: 'Pulling…',
    pull_firebase_confirm:
      'Pull ONLY missing Firebase records into Postgres?\n\nVenues / orgs / events / tickets / sales — existing rows are skipped.\nFor existing events: missing tickets/sales are added; date diffs are synced.',
    pull_firebase_ok:
      'Pull OK: %{venues} venues, %{orgs} orgs, %{events} events (+%{dates} dates), %{sales} sales, %{tickets} tickets (%{failed} failed)',
    pull_firebase_error: 'Pull error: %{message}',
  },
  create_wizard: {
    new_event: 'New Event',
    step1_desc: 'Step 1 of 2 — Choose the event type.',
    step2_desc: 'Step 2 of 2 — Choose how dates work for this event.',
    event_type: 'Event Type',
    date_type: 'Event Date Type',
    back: 'Back',
    next: 'Next',
    step1_hint: 'Select an event type, then click Next.',
    step2_hint: 'Select a date type, then click Next to continue to the create form.',
    select_event_type_first: 'Please select an event type first.',
    select_date_type_first: 'Please select a date type first.',
    type_1_title: 'Standard Event',
    type_2_title: 'Area Layout Event',
    type_3_title: 'Seated Event',
    oneoff_title: 'Single Date / One Off',
    session_title: 'Multiple Dates / Sessions',
    type1_desc: 'Standard tickets without a seating or area map.',
    type2_desc: 'Sell tickets by area / zone on a venue layout.',
    type3_desc: 'Assigned seats with a seating chart.',
    oneoff_desc: 'One single date and time for this event.',
    session_desc: 'Multiple dates or sessions under one event.',
    header_edit: '%{name} / %{type} (%{dateType})',
    header_clone: 'Clone: %{name} / %{type} (%{dateType})',
    header_new: 'New %{type} (%{dateType})',
    clone_name_fallback: 'New event',
    clone_banner:
      'Cloned event — sessions, products and settings were copied with new IDs. Review dates before publishing. Layout was deep-copied (source event layout is not shared).',
    clone_name: '%{name} (Copy)',
    clone_confirm:
      'Are you sure you want to clone this event? Review the dates before publishing — sessions and products are copied with new IDs.',
    clone_error: 'Could not clone event. Check stock exists for this event.',
  },
  pages: {
    active_events_title: 'Active Events List',
    active_events_desc: 'You can find below the active list of events within your permissions set.',
    past_events_title: 'Past Events List',
    past_events_desc: 'Search by name, slug, venue, city or category.',
    pending_events_title: 'Pending Events for Approval',
    push_notifications_title: 'Mobile Push Notification Sender',
    push_notifications_desc: 'Legacy mobile, new mobile and web notification channels.',
    sale_report_title: 'Sales Report and Settlements',
  },
};
